import { Onboarding } from './Onboarding';

export { Onboarding };
